/**
 * Validates if the provided URL is a valid Microsoft Teams webhook URL
 */
export function isValidTeamsWebhookUrl(url: string): boolean {
  try {
    const urlObj = new URL(url);

    // Check if it's a Teams webhook URL
    // Teams webhooks can be either:
    // 1. Power Automate/Logic Apps: https://*.logic.azure.com:443/workflows/...
    // 2. Office 365 Connectors: https://*.webhook.office.com/...
    return (
      urlObj.protocol === 'https:' &&
      (urlObj.hostname.endsWith('.logic.azure.com') ||
        urlObj.hostname.endsWith('.webhook.office.com'))
    );
  } catch {
    return false;
  }
}
